export default "__VITE_ASSET__e4f9cae5__"